import * as angular from 'angular';

/**
 *BTCPKP-6392 CR-U 3.5.8.2 Trader list
 *Controller for trader lists
 */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('TradersPlatformSettingsCtrl', TradersPlatformSettingsCtrl);

    function TradersPlatformSettingsCtrl(
        traderListsService,
        TraderList,
        ShipperUser,
        Shipper,
        $log,
        $location,
        $scope,
        authService,
        identifierService,
        arrayService,
        TradeProposals
    ) {
        var vm = this;

        // TODO Bindable members up top for all the other bound values
        vm.uiDeleteTraderListErrorRes = false;
        vm.uiDeleteTraderListSuccessRes = false;
        vm.uiSecondaryTraderlistStillInUse = false;
        vm.uiTraderListNameIsInUse = false;
        vm.addNotPublishedShipper = false;
        vm.uiNoTraderLists = false;
        vm.predicate = 'name';
        vm.reverse = false;
        vm.ownEIC = '';
        vm.loadTradeProposals = loadTradeProposals;
        vm.loadTradeResponses = loadTradeResponses;
        vm.lastSelectedTraderListName = '';

        var promise = Shipper.loggedInShipper(undefined, function (res) {
            if ($.isEmptyObject(res.toJSON())) {
                authService.logOut();
            }
            vm.ownEIC = identifierService.getIdentifierFromIdentifierList(
                res.identifierList,
                identifierService.IDENTIFIERS.EIC
            );
        }).$promise;

        promise.then(function () {
            //check if User is signed in
            ShipperUser.loggedInShipperUser(function (res) {
                if ($.isEmptyObject(res.toJSON())) {
                    authService.logOut();
                }
                //  $log.debug(JSON.stringify(res));
                if ('firstName' in res) {
                    // Query Trading Lists
                    TraderList.specificQuery(
                        { dontCache: new Date().getTime() },
                        function (res) {
                            vm.traderLists = res;
                            traderListsService.setTraderLists(res);
                            if (vm.traderLists.length < 1) {
                                vm.uiNoTraderLists = true;
                            }
                        },
                        function (err) {
                            $log.debug(err);
                        }
                    );
                }
            });
        });

        //query public traders for display in paginator
        vm.traders = [];

        TraderList.publicQuery(
            function (res) {
                vm.traders = filterTraders(res);
                //  $log.debug('trader: ' + JSON.stringify(res));
            },
            function (err) {
                $log.debug(err);
            }
        );

        function filterTraders(input) {
            var traders = input.data;
            var result = [];
            angular.forEach(traders, function (value) {
                var currentEIC =
                    identifierService.getIdentifierFromIdentifierList(
                        value.identifierList,
                        identifierService.IDENTIFIERS.EIC
                    );
                if (currentEIC !== vm.ownEIC) {
                    result.push(value);
                }
            });
            return result;
        }

        //Copies are needed, otherwise the objects are referenced
        vm.currentTraderList = angular.copy(
            traderListsService.getCurrentTraderList()
        );
        vm.traderListHeading = traderListsService.getTraderListHeading();
        vm.showTraders = function (traderList) {
            traderList.showTraders = !traderList.showTraders;

            traderList.showTradeProposals = true;
            traderList.showTradeResponses = false;

            loadTradeProposals(traderList);
        };

        function loadTradeProposals(traderList) {
            if (
                angular.isUndefined(traderList.proposals) ||
                vm.lastSelectedTraderListName != traderList.name
            ) {
                traderList.loading = true;
                TradeProposals.proposalsTraderList(
                    { traderListName: traderList.name },
                    function (res) {
                        traderList.proposals = res;
                        traderList.loading = false;
                        vm.lastSelectedTraderListName = traderList.name;
                    }
                );
            } else {
                traderList.loading = false;
            }
            traderList.showTradeProposals = true;
            traderList.showTradeResponses = false;
        }

        function loadTradeResponses(traderList) {
            if (
                angular.isUndefined(traderList.responses) ||
                vm.lastSelectedTraderListName != traderList.name
            ) {
                traderList.loading = true;
                TradeProposals.responsesTraderList(
                    { traderListName: traderList.name },
                    function (res) {
                        traderList.responses = res;
                        traderList.loading = false;
                        vm.lastSelectedTraderListName = traderList.name;
                    }
                );
            } else {
                traderList.loading = false;
            }
            traderList.showTradeProposals = false;
            traderList.showTradeResponses = true;
        }

        vm.deleteTrader = function (traderEic) {
            for (var i = 0; i < vm.currentTraderList.shipperList.length; i++) {
                if (
                    vm.getEIC(
                        vm.currentTraderList.shipperList[i].identifierList
                    ) === traderEic
                ) {
                    vm.currentTraderList.shipperList.splice(i, 1);
                }
            }
        };

        vm.editTraderList = function (traderList) {
            traderListsService.setCurrentTraderList(mapToDto(traderList));
            traderListsService.setOldTraderList(mapToDto(traderList));
            traderListsService.setTraderListHeading('Edit');
            $location.path('platform-settings/new-trader-list');
        };

        vm.createTraderList = function () {
            traderListsService.setCurrentTraderList({});
            traderListsService.setOldTraderList({});
            traderListsService.setTraderListHeading('Create');
        };

        vm.deleteTraderList = function () {
            vm.uiDeleteTraderListSuccessRes = false;
            TraderList.delete(
                { traderListName: vm.traderListToDelete.name },
                function () {
                    for (var i = 0; i < vm.traderLists.length; i++) {
                        if (
                            vm.traderLists[i].name ===
                            vm.traderListToDelete.name
                        ) {
                            vm.traderLists.splice(i, 1);
                        }
                    }
                    //update traderLists in Service
                    traderListsService.setTraderLists(vm.traderLists);
                    vm.uiDeleteTraderListSuccessRes = true;
                    if (vm.traderLists.length < 1) {
                        vm.uiNoTraderLists = true;
                    }
                },
                function (err) {
                    if (
                        err.data.description ===
                        traderListsService.SECONDARY_TRADERLIST_STILL_IN_USE
                    ) {
                        vm.uiSecondaryTraderlistStillInUse = true;
                    }
                    vm.uiDeleteTraderListErrorRes = true;
                }
            );
        };

        vm.addTrader = function (trader) {
            if (vm.currentTraderList.shipperList) {
                vm.currentTraderList.shipperList.push(trader);
            } else {
                vm.currentTraderList.shipperList = [];
                vm.currentTraderList.shipperList.push(trader);
            }
            traderListsService.setCurrentTraderList(
                angular.copy(vm.currentTraderList)
            );
        };

        vm.cancel = function () {
            vm.traderLists = angular.copy(traderListsService.getTraderLists());
            $location.path('platform-settings/secondary-trading');
        };

        vm.saveChanges = function () {
            //Check if the name of an existing trader list was edited
            var oldTraderList = traderListsService.getOldTraderList();
            if (
                oldTraderList.name &&
                oldTraderList.name !== vm.currentTraderList.name
            ) {
                vm.traderListToDelete = oldTraderList;
                vm.deleteTraderList();
            }
            //Check if a new list is created with an existing name
            else if (
                angular.isUndefined(oldTraderList.name) &&
                !angular.isUndefined(vm.traderLists)
            ) {
                for (var i = 0; i < vm.traderLists.length; i++) {
                    if (vm.traderLists[i].name === vm.currentTraderList.name) {
                        vm.uiTraderListNameIsInUse = true;
                        return;
                    }
                }
            }
            delete vm.currentTraderList.showTraders;
            TraderList.save(
                vm.currentTraderList,
                function () {
                    $location.path('/platform-settings/secondary-trading');
                    traderListsService.updateTraderLists(vm.currentTraderList);
                },
                function (err) {
                    $log.debug(err);
                    vm.uiTraderListSaveError = true;
                    const errorMessage =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.';
                    vm.saveErrorMessage = errorMessage;
                }
            );
        };

        vm.traderListIsEmpty = function () {
            return !(
                angular.isDefined(vm.currentTraderList.shipperList) &&
                vm.currentTraderList.shipperList.length > 0
            );
        };

        vm.getEIC = function (identifierList) {
            return arrayService.getElementInArrayWhereKeyEqualsValue(
                'id',
                identifierList,
                'type',
                'EIC'
            );
        };

        /**
         * Filter that filters already chosen traders from the trader list
         * @param value is trader
         * @returns {boolean} true if trader is not selected else false
         */
        vm.filterShippers = function (value) {
            var isSelected = true;
            if (!vm.traderListIsEmpty()) {
                for (
                    var i = 0;
                    i < vm.currentTraderList.shipperList.length;
                    i++
                ) {
                    if (
                        vm.getEIC(
                            vm.currentTraderList.shipperList[i].identifierList
                        ) === vm.getEIC(value.identifierList)
                    ) {
                        isSelected = false;
                    }
                }
            }
            return isSelected;
        };

        //local Filter; Perhaps sorting on the server will be needed
        vm.filterShippersByEIC = function (value) {
            if (angular.isUndefined(vm.getEIC(value.identifierList))) {
                return false;
            } else {
                if (vm.EICorName && vm.EICorName.length > 1) {
                    return isWantedTrader(value);
                } else {
                    return true;
                }
            }
        };

        function isValidEIC(eic) {
            var regExp = /[A-Za-z0-9]{2}X[A-Z-0-9]{13}/;
            var isValid = eic.search(regExp);
            return isValid === 0;
        }

        vm.addNotPublishedTrader = function () {
            var notPublicTrader = {
                identifierList: [
                    {
                        type: 'EIC',
                        id: vm.EICorName
                    }
                ],
                agreedToPublish: true
            };
            vm.addTrader(notPublicTrader);
            vm.EICorName = '';
        };

        $scope.$watch(
            function () {
                return vm.EICorName;
            },
            function () {
                if (
                    angular.isUndefined(vm.EICorName) ||
                    vm.EICorName.length !== 16
                ) {
                    vm.addNotPublishedShipper = false;
                } else if (!angular.isUndefined(vm.EICorName)) {
                    if (traderIsInPublicList()) {
                        vm.addNotPublishedShipper = false;
                    } else if (isValidEIC(vm.EICorName)) {
                        vm.addNotPublishedShipper = true;
                    }
                }
            }
        );

        function traderIsInPublicList() {
            var isContained = false;
            for (var i = 0; i < vm.traders.length; i++) {
                if (isWantedTrader(vm.traders[i])) {
                    isContained = true;
                }
            }
            return isContained;
        }

        function isWantedTrader(value) {
            var isContained = false;
            //Everything toLowerCase to make the filter case insensitive
            var eic = vm.getEIC(value.identifierList).toLowerCase();
            var name = value.name.toLowerCase();
            var comparable = vm.EICorName.toLowerCase();
            //If eic is contained
            if (eic.indexOf(comparable) > -1 || eic === comparable) {
                isContained = true;
            }
            // If name is contained
            if (name.indexOf(comparable) > -1 || name === comparable) {
                isContained = true;
            }
            return isContained;
        }

        function mapToDto(traderList) {
            var traderListDto: any = {};
            traderListDto.name = traderList.name;
            traderListDto.deletable = traderList.deletable;
            traderListDto.shipperList = traderList.shipperList;
            return traderListDto;
        }

        vm.order = function (predicate) {
            vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
            vm.predicate = predicate;
        };

        vm.orderByPredicate = function (trader) {
            if (vm.predicate === 'name') {
                return trader.name;
            }
            if (vm.predicate === 'eic') {
                return vm.getEIC(trader.identifierList);
            }
        };
    }
})();
